import React, { useEffect, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import CustomSelect from "../../../Shared/Components/Form/CustomSelect";
import { getContactsApi } from "../../../Shared/Api/GetContacts";
import { SUCCESS_API_RESPONSE } from "../../../Shared/Constants/api";
import { MODEL_TYPE_ENUM } from "../../../Shared/Constants/enums";
import { FormatNoteHasModelList } from "../../../Shared/Utils/Formatters/FormarNoteHasModel";
import { Badge } from "reactstrap";

export default function FormAddContactComponent({
  setCurrentContacts,
  currentContacts,
}) {
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    fetchAndFormatContacts();
  }, []);

  const fetchAndFormatContacts = async () => {
    const response = await getContactsApi();
    if (response.result === SUCCESS_API_RESPONSE) {
      const formattedContacts = FormatNoteHasModelList(response.data?.items);
      setContacts(formattedContacts);
    }
  };

  const handleContactChange = (contact) => {
    setSelectedContact(contact);
  };

  const addContactToList = () => {
    if (!selectedContact) return;

    const existingContact = findExistingContact(selectedContact.id);

    if (existingContact) {
      updateExistingContact(existingContact);
    } else {
      addNewContact();
    }
  };

  const findExistingContact = (contactId) => {
    return currentContacts.find((c) => c.model_id === contactId);
  };

  const updateExistingContact = (contact) => {
    delete contact.deleted;
    setCurrentContacts([...currentContacts]);
  };

  const addNewContact = () => {
    setCurrentContacts([
      ...currentContacts,
      {
        ...{
          model_type: MODEL_TYPE_ENUM.CONTACT,
          model_id: selectedContact.id,
          name: selectedContact.name,
        },
      },
    ]);
  };

  return (
    <FormGroup>
      <Label>Vincular contactos a esta nota</Label>
      <div className="d-flex ">
        <CustomSelect
          placeholder="Buscar contacto"
          className="custom-select-no-border custom-select-sm form-control border-0"
          items={contacts}
          item={selectedContact}
          customChangeHandler={handleContactChange}
        />
        <Btn
          attrBtn={{
            color: "outline-primary",
            className: "ms-2",
            onClick: addContactToList,
          }}
        >
          Agregar
        </Btn>
      </div>
    </FormGroup>
  );
}
